module.exports = __webpack_public_path__ + "img/cryptocoins.2c600db0.svg";